import React, { useEffect, useState } from 'react'

import { Button, ModalBox } from '@fourthwall/components'
import { useHash } from '@utils/useHash/useHash'

import { SHIPPING_MODAL_HASH } from '../../../../../Product.consts'
import { AssistedShippingContent } from './components/AssistedShippingContent'
import { SelfShippingContent } from './components/SelfShippingContent'
import * as S from './styled'

export type ShippingChangeOption = {
  id: 'WEIGHT_BASED_SELF_SHIPPING' | 'SHIPPING_3PL'
}

type ChangeProductionMethodModalProps = {
  initialOption: ShippingChangeOption
  options: Array<ShippingChangeOption>
  onConfirm?: (option: ShippingChangeOption) => void
  onClose?: () => void
  onRequestClose?: () => void
}

export const SelfOrAssistedShippingChoiceModal = ({
  initialOption,
  options,
  onConfirm,
  onClose,
}: ChangeProductionMethodModalProps) => {
  const [selectedOption, setSelectedOption] = useState<ShippingChangeOption>(initialOption)

  const { hasHash, hash } = useHash()

  const handleConfirm = () => {
    onConfirm?.(selectedOption)
    onClose?.()
  }

  useEffect(() => {
    // NOTE: we need this so that the modal manages the visibility of the modal itself (for example, when the user clicks on the back button)
    if (!hasHash(SHIPPING_MODAL_HASH)) {
      onClose?.()
    }
  }, [hasHash, hash, onClose])

  return (
    <ModalBox
      size="large"
      title="Select who will ship orders"
      onClose={onClose}
      buttons={[
        <Button label="Cancel" appearance="secondary" onClick={onClose} />,
        <Button label="Confirm" appearance="primary" onClick={handleConfirm} />,
      ]}
    >
      <S.Container id={SHIPPING_MODAL_HASH}>
        {options.map((option) => (
          <S.Column
            key={option.id}
            $active={selectedOption.id === option.id}
            onClick={() => {
              setSelectedOption(option)
            }}
          >
            {option.id === 'WEIGHT_BASED_SELF_SHIPPING' ? (
              <SelfShippingContent />
            ) : (
              <AssistedShippingContent />
            )}
          </S.Column>
        ))}
      </S.Container>
    </ModalBox>
  )
}
